import {
	Implemented, NotImplemented, NeedsAttention, WillNotApply,
	WillNotImplement, ConditionallyImplemented, PartiallyImplemented,
} from '@/models/enums-generated'
import { getMethodStatusText, formatDate } from '@/services/utils'
import type { MethodImportMatchedMethod as MatchedMethod } from '@/models/api-generated'

export const DoNotImport = 'DoNotImport'

export const validStatusOptions = [
	Implemented, NotImplemented, NeedsAttention, WillNotApply,
	WillNotImplement, ConditionallyImplemented, PartiallyImplemented,
].map((v) => ({ value: v, label: getMethodStatusText(v) }))

export const statusIconMap: Record<string, string> = {
	[Implemented]: 'bi bi-circle-fill pie1',
	[NotImplemented]: 'bi bi-circle-fill pie3',
	[PartiallyImplemented]: 'bi bi-circle-fill pie2',
	[ConditionallyImplemented]: 'bi bi-exclamation-circle-fill pie1',
	[WillNotApply]: 'bi bi-circle-fill pie4',
	[WillNotImplement]: 'bi bi-circle-fill pie4',
	[NeedsAttention]: 'bi bi-circle-fill pie6',
}

export function statusIcon(status: string): string {
	return statusIconMap[status] ?? 'bi bi-question-circle text-muted'
}

export function importResponsibleIcon(type?: string): string {
	if (type === 'roles') return 'bi-people-fill'
	if (type === 'users') return 'bi-person-fill pie1'
	return 'bi-question-circle text-muted'
}

export function effectiveStatus(status: string, map: Record<string, string>): string {
	return map[status] || status
}

export function isDoNotImport(status: string, map: Record<string, string>): boolean {
	return map[status] === 'DoNotImport'
}

export function hasStatusMismatch(status: string): boolean {
	return !status || !getMethodStatusText(status)
}

export function dateDay(v: string | null | undefined): string {
	return v ? v.substring(0, 10) : ''
}

export function fmtDate(v: string | null | undefined): string {
	if (!v) return '—'
	return formatDate(v)
}

export function hasDiff(m: MatchedMethod): boolean {
	const c = m.current
	const i = m.imported
	return (
		(!!i.status && c.status !== i.status) ||
		(i.responsibleId != null && c.responsibleId !== i.responsibleId) ||
		(i.dueDate != null && dateDay(c.dueDate) !== dateDay(i.dueDate)) ||
		(!!i.comment && c.comment !== i.comment)
	)
}
